var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.335 21.89v-6.035c0-.566.46-1.024 1.03-1.024h2.06c.569 0 1.03.458 1.03 1.024v6.034m0-11.913c0 .565-.461 1.024-1.03 1.024h-2.06c-.57 0-1.03-.459-1.03-1.024V6.79c0-.566.46-1.024 1.03-1.024h2.06c.569 0 1.03.458 1.03 1.024v3.186Zm3.719 7.927v-2.048c0-.566.46-1.024 1.03-1.024h1.443c.569 0 1.03.458 1.03 1.024v2.048h-3.503Zm-.406-7.685V3a1 1 0 0 0-1-1H7a4 4 0 0 0-4 4v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-6.782a2 2 0 0 0-2-2h-4.232a1 1 0 0 1-1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.f8bedcfb7e577818dac519339a44129c.svg";
export { ForwardRef as ReactComponent };